import React from "react";
import Menu from "../Menu";
import Footer from "../footer";
import TextField, { Input } from "@material/react-text-field";
import { Redirect } from "react-router-dom";
import * as Api from "../api/main";
import LoadingOverlay from "react-loading-overlay";
import { ClipLoader } from "react-spinners";
import { connect } from "react-redux";
import { set_smscode, set_smserror, set_smserrorvalidator } from "../actions/smsValidationAction";
import { set_loading } from "../actions/loadingActions";
import cookie from "react-cookies";
import ReactGA from "react-ga";
import { set_redirectToValidateOrFinish, set_url_for_finish } from "../actions/stepTwoActions";
import { Link } from "react-router-dom";
// import {ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
// import { hotjar } from 'react-hotjar';
const urlWeb = "https://sgroshi.com.ua";
class SmsValidation extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.buttonNext = this.buttonNext.bind(this);
    this.renderRedirect = this.renderRedirect.bind(this);
    this.set_code_validator = this.set_code_validator.bind(this);
  }

  state = {
    timerFlag: true,
    timerState: 120,
  };

  componentDidMount() {
    ReactGA.initialize("UA-82486421-1");
    ReactGA.pageview("/smsvalidation");
  }

  set_code_validator(value) {
    if (value.length <= 5) {
      this.props.dispatch(set_smscode(value.toUpperCase()));
    }
  }

  switchResponseCode(code) {
    switch (code) {
      case 1:
        return true;
      case 3:
        return true;
      case 4:
        return true;
      case 6:
        return true;
      default:
        return false;
    }
  }

  async buttonNext() {
    const order_id = cookie.load("order_id");
    const unic_hit = cookie.load("unic_hit");
    const joint_id = cookie.load("joint_id");
    const referer_site = "PG";
    let partnersLinkToRedirect = cookie.load("partnersRedirectLing");
    console.log(
      "this.props.store.userDataReducer.final_code_url",
      this.props.store.userDataReducer.final_code_url,
    );

    // Обработчик события сабмит
    if (this.props.store.validationReducer.smscode.length < 4) {
      this.props.dispatch(set_smserrorvalidator(true));
      setTimeout(() => {
        this.props.dispatch(set_smserrorvalidator(false));
      }, 3000);
    } else {
      this.props.dispatch(set_loading(true));
      try {
        const responce = await Api.SmsValidete(
          this.props.store.userDataReducer.token,
          this.props.store.validationReducer.smscode,
        );
        const partnersURL = cookie.load("partnersURL");
        if (responce) {
          if (partnersURL && this.switchResponseCode(responce.data.code)) {
            await Api.sendPostback(responce.data.code).then(async (data) => {});
          }

          if (
            responce.data.client_id &&
            this.switchResponseCode(responce.data.code) &&
            partnersURL
          ) {
            window.location.href =
              // Api.urlWeb +
              process.env.REACT_APP_SITE_REDIRECT_URL +
              "/kabinet/profile/" +
              partnersURL +
              "&client_id=" +
              responce.data.client_id+
            "&order_id=" + order_id + "&order=" + order_id + "&unic_hit=" + unic_hit +
            "&joint_id=" + joint_id + "&referer_site=" + referer_site;
          } else if (responce.data.client_id && !partnersURL) {
            window.location.href =
              // Api.urlWeb +
              process.env.REACT_APP_SITE_REDIRECT_URL +
              "/kabinet/profile?client_id=" +
              responce.data.client_id+
            "&order_id=" + order_id + "&order=" + order_id + "&unic_hit=" + unic_hit +
            "&joint_id=" + joint_id + "&referer_site=" + referer_site;
          } else {
            this.props.dispatch(set_url_for_finish("/final-1"));
          }

          if (this.props.store.userDataReducer.final_code_url === 4) {
            this.props.dispatch(set_url_for_finish("/final-4"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
          }

          if (this.props.store.userDataReducer.final_code_url === 1 && !responce.data.client_id) {
            this.props.dispatch(set_url_for_finish("/final-1"));
            this.props.dispatch(set_redirectToValidateOrFinish(true));
          }
          this.props.dispatch(set_loading(false));
        } else {
          this.props.dispatch(set_url_for_finish("/final-1"));
          this.props.dispatch(set_smserror(true));
          setTimeout(() => {
            this.props.dispatch(set_smserror(false));
          }, 3000);
          this.props.dispatch(set_loading(false));
        }
      } catch (error) {
        console.log(error);
        this.props.dispatch(set_smserror(true));
        setTimeout(() => {
          this.props.dispatch(set_smserror(false));
        }, 3000);
        this.props.dispatch(set_loading(false));
      }
    }
  }

  async buttonReSend() {
    // Повторная отправка смс
    this.props.dispatch(set_loading(true));
    if (this.state.timerFlag) {
      let timer = 120;
      // setTimerFlag(false);
      this.setState((prevState) => ({
        ...prevState,
        timerFlag: false,
      }));
      const go = setInterval(() => {
        timer = timer - 1;
        this.setState((prevState) => ({
          ...prevState,
          timerState: timer,
        }));
        if (timer === 0) {
          clearInterval(go);
          this.setState((prevState) => ({
            ...prevState,
            timerFlag: true,
          }));
        }
      }, 1000);
    }
    try {
      const response = await Api.SmsReSendValidete(
        this.props.store.userDataReducer.token,
        this.props.store.userDataReducer.phone,
      );
      if (response) {
        this.props.dispatch(set_loading(false));
        //console.log(response.data)
      }
    } catch (error) {
      console.log(error);
    }
  }

  renderRedirect = () => {
    if (this.props.store.validationReducer.redirectNext) {
      if (this.props.store.userDataReducer.final_code_url === 1) {
        return <Redirect to={{ pathname: "/final-1" }} />;
      } else if (this.props.store.userDataReducer.final_code_url === 4) {
        return <Redirect to={{ pathname: "/final-4" }} />;
      }
    }
    if (!this.props.store.userDataReducer.phone) {
      return <Redirect to={{ pathname: "/registration-step1-new2" }} />;
    }
  };

  render() {
    let { inn, last_name, fio, second_name, doc_number, city, phone, birth_date, doc_date } =
      this.props.store.userDataReducer;
    return (
      <div>
        <Menu />
        <LoadingOverlay
          className="loading"
          text="Триває обробка даних"
          active={this.props.store.loadingReducer.loading}
          spinner={
            <div className="spiner">
              <ClipLoader className="spiner" color={"#fff"} />
            </div>
          }
        ></LoadingOverlay>
        {this.renderRedirect()}
        <div className="main-block-validator">
          <h1>Заповніть заявку на кредит</h1>
          <div className="inner-block">
            <div class="data-validation ">
              <div class="title">Підтвердження даних</div>
              <div class="credit-text-wrapper">
                <div class="credit-text-message">
                  На Ваш номер <span>{phone}</span> протягом хвилини ми надішлемо sms-повідомлення з кодом
                  для підтвердження заявки
                </div>
                <div class="credit-text-message">
                  <p>
                    Я розумію, що підписую анкету на нижче вказаних умовах, підписуючи данну анкету
                    одноразовим ідентифікатором (код з смс-повідомлення):
                  </p>
                </div>
              </div>

              <div class="sms-code-form">
                <TextField
                  label="Введіть код з СМС-повідомлення*"
                  margin="normal"
                  variant="outlined"
                  style={{ width: "48%", marginBottom: "0" }}
                >
                  <Input
                    value={this.props.store.validationReducer.smscode}
                    onChange={(e) => this.set_code_validator(e.currentTarget.value)}
                    variant="outlined"
                  />
                </TextField>

                <button className="code-form-input" onClick={(e) => this.buttonNext()}>
                  {" "}
                  Підтверджую
                </button>
              </div>
              {this.props.store.validationReducer.error ? (
                <div className="smserrore">Невірний код з СМС</div>
              ) : null}
              {this.props.store.validationReducer.errornotvalid ? (
                <div className="smserrore">Введіть код з СМС-повідомлення</div>
              ) : null}

              <div class="sms-issues">
                Якщо ви не отримали код з СМС-повідомлення, то{" "}
                <button
                  disabled={this.state.timerFlag ? false : true}
                  style={
                    this.state.timerFlag
                      ? { color: "#0056a8", background: "white" }
                      : { color: "rgba(0, 182, 0, 1)" }
                  }
                  onClick={(e) => this.buttonReSend()}
                >
                  {this.state.timerFlag
                    ? `Відправити ще раз`
                    : ` Повторно можно відправити через ${this.state.timerState}`}
                </button>
              </div>
            </div>

            <div className="oferta-wrapper">
              <div className="oferta-article">
                <h2>Анкета позичальника</h2>
                <ol>
                  <li>Прізвище, ім’я, по батькові: {last_name + " " + fio + " " + second_name}</li>
                  <li>Дата народження: {birth_date}</li>
                  <li>Місце проживання: {city}</li>
                  <li>Ідентифікаційний код: {inn}</li>
                  <li>Паспорт: {doc_number + " " + doc_date}</li>
                  <li>Телефон: {phone}</li>
                </ol>
                <p>
                  Я, {last_name + " " + fio + " " + second_name}, 16.10.2019 підписанням цієї
                  анкети:
                  <br />
                  1.Підтверджую, що зазначена мною інформація в анкеті, а також додані до неї
                  документи та/або копії документів, не містять будь-яких неточних, неправдивих або
                  недостовірних відомостей, складені та/або отримані у порядку, передбаченому чинним
                  законодавством України;
                  <br />
                  2.Підтверджую, що мені відомі наслідки та відповідальність, передбачені чинним
                  законодавством України, за подання неточних, неправдивих або недостовірних
                  відомостей, а також документів, що містять неточні, неправдиві або недостовірні
                  відомості, складені та/або отримані у незаконному порядку;
                  <br />
                  3.Надаю ТОВ «Споживчий Центр» свою однозначну, безумовну та безвідкличну згоду на
                  обробку, зберігання, використання, поширення і отримання будь-якої інформації про
                  мене, а також на обробку будь-яких моїх персональних даних, фото та відео фіксацію
                  з метою прийняття рішення про видачу або невидачу кредиту.
                  <br />
                  4.Я не заперечую обробку, в тому числі передачу, моїх персональних даних від ТОВ
                  «Споживчий центр» третім особам у випадку стягнення заборгованості в об’ємі
                  необхідному для виконання таких дій.
                  <br />
                  5.Я розумію, що Кредитор залишає за собою право звертатися до будь-якої особи,
                  відомої або невідомої мені, інформація від якої, як вважає Кредитор, може сприяти
                  в ухваленні рішення щодо видачі або не видачі мені кредиту;
                  <br />
                  6.Із статтями 190, 192, 209, 222 Кримінального Кодексу України ознайомлений. Із
                  положеннями Закону України “Про захист персональних даних” ознайомлений.
                  <br />
                  7. Я надаю Кредитору свою згоду та право передавати, збирати, зберігати,
                  використовувати, отримувати, поширювати, обробляти будь-яку інформацію про мене
                  до/від/через:
                  <br />
                  ТОВ Українське бюро кредитних історій, що находиться за адресою: 01001, м.Київ,
                  вул.Грушевського, 1-д;
                  <br />
                  ПАТ «Перше всеукраїнське бюро кредитних історій», 02002, м. Київ, вул. Марини
                  Раскової, буд. 11;
                  <br />
                  ПАТ «Міжнародне бюро кредитних історій», 03062, м. Київ, просп. Перемоги, буд. 65,
                  офіс 306;
                  <br />
                  ТОВ «Незалежне бюро кредитних історій», 01033, м. Київ, вул. Володимирська, буд.
                  78, офіс 1.
                  <br />
                  8. Відповідь позичальника про прийняття пропозиції (акцепт)
                  <br />
                  8.1. Підтверджую, що я однозначно та безумовно приймаю (акцептую) пропозицію про
                  укладення кредитного договору (оферти), яка розміщена на сайті ТОВ «Споживчий
                  центр» https://sgroshi.com.ua/, з якою я ознайомився перед підписанням даного
                  акцепту, у разі укладення мною зазначеного в ній договору.
                  <br />
                  8.2. Я підтверджую свою згоду на укладення кредитного договору на умовах, які
                  містяться у зазначеній оферті, та у заявці до кредитного договору, яка буде
                  сформована на вказаному сайті після моєї ідентифікації, обрання мною конкретних
                  умов, їх схвалення Кредитором.
                  <br />
                  8.3. Я розумію, що для підписання електронного кредитного договору на
                  вищезазначених умовах я повинен підписати одноразовим ідентифікатором (код з смс –
                  повідомленням) акцепт в електронній формі на сайті ТОВ «Споживчий центр»
                  https://sgroshi.com.ua/.
                  <br />
                </p>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default connect((state) => ({ store: state }))(SmsValidation);



// WEBPACK FOOTER //
// src/pages/smsvalidation.js